import React, {useState} from 'react';
import {  Dialog,
          DialogTitle,
          DialogContent,
          DialogContentText,
          DialogActions,
          Button,
          Checkbox,
          FormControlLabel } from "@mui/material";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const RowDialog = ({open, onClose, tableId, category, auth, onLogout}) => {
//  console.log("Table ID in Dialog to delete:", tableId);
  let deletecategory = category
  const [checkedDelete, setCheckedDelete] = useState(false);
  const [error, setError] = useState(null);

  // Reset checkbox when dialog closes
  React.useEffect(() => {
    if (!open) {
      setCheckedDelete(false);
      setError(null);
    }
  }, [open]);

  async function handleDelete (tableId) {
    try {
      // console.log("Delete Request:", { tableName: tableId , category: deletecategory })
      const response = await fetch(`${API_BASE_URL}/rawdata/delete-table-data`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              Authorization:`Bearer ${auth.token}`
          },
          body: JSON.stringify({ tableName: tableId , category: deletecategory })
      });
      const data = await response.json();
      // console.log("Delete Response:", data);
    } catch (error) {
      let errorMessage = "Failed to delete table. Please try again.";
      if (error.message.includes('401')) {
        errorMessage = "Unauthorized: Please log in again.";
        onLogout(); // logout if unauthorized
      } else if (error.message.includes('403')) {
        errorMessage = "Forbidden: You do not have permission to delete this table.";
      } else if (error.message.includes("404")) {
        errorMessage = "Table not found.";
      }

      setError(errorMessage);
    }
  }

  return (

      <Dialog
        open={open}
        onClose={() => {
        onClose();
        setError(null); // Clear error when closing
      }}>
        <DialogTitle id="alert-dialog-title">
         Delete {tableId ? `Table ID :- ${tableId}` : ""}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this log?
          </DialogContentText>
          <FormControlLabel
          required
          control={
            <Checkbox
              checked={checkedDelete}
              onChange={e => setCheckedDelete(e.target.checked)}
            />
          }
          label="Enable to delete this log"
        />
        </DialogContent>
        <DialogActions>
          <Button
          color='error'
          disabled={!checkedDelete}
          style={{ filter: !checkedDelete ? 0.5 : 1 }}
          onClick={() => {
              handleDelete(tableId);
              // Add your delete logic here
              onClose();
            }}
          >
            DELETE
          </Button>
          <Button onClick={() => {
            onClose();
            setError(null); // Clear error when closing
          }}>
            CLOSE
          </Button>
        </DialogActions>
      </Dialog>

  );
}

export default RowDialog;